import { Box, Grid, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';

const Theming = (props) =>
{
	const { setColorStates, colorStates } = props;

	const { language } = useContext(LanguageContext);

	const handleColorChange = (e) =>
	{
		const { name, value } = e.target;

		setColorStates((prev) => ({
			...prev,
			[name] : value
		}));
	};

	return (
		<Stack direction='column' py='var(--pixel8)' justifyContent={'center'}>
			<Typography variant='inherit' fontSize='var(--pixel18)' fontWeight='var(--font500)' px='var(--pixel8)'>
				{language.theming}
			</Typography>
			<Box
				alignItems='center'
				justifyContent='center'
				display='flex'
				sx={{
					border       : '1px dashed var(--grayA8)',
					borderRadius : '13px',
					margin       : 'var(--pixel8)',
					height       : '170px'
				}}
			>
				<Grid item container spacing={1} p='var(--pixel8)'>
					<Grid item xs={12}>
						<Stack direction='column'>
							<Typography variant='inherit' sx={{ fontSize: 'var(--pixel14)', fontWeight: '500' }} pl='var(--pixel8)'>
								{language.primary}
							</Typography>
							<Stack direction='row' position='relative' alignItems={'center'} pt='var(--pixel4)'>
								<Box
									sx={{
										background   : colorStates?.primaryColor,
										padding      : 'var(--pixel8)',
										borderRadius : 'var(--pixel4)',
										height       : 'var(--pixel40)',
										width        : 'var(--percent100)',
										margin       : '0 8px'
									}}
								/>
								<input
									id='colorPicker'
									type='color'
									value={colorStates?.primaryColor}
									name='primaryColor'
									onChange={(e) => handleColorChange(e)}
									style={{
										position : 'absolute',
										top      : '0',
										left     : '0',
										width    : 'var(--percent100)',
										height   : 'var(--percent100)',
										opacity  : '0',
										cursor   : 'pointer'
									}}
								/>
								<Box
									sx={{
										border       : '1px solid #636363',
										padding      : 'var(--pixel4)',
										borderRadius : 'var(--pixel4)',
										marginRight  : 'var(--pixel8)',
										marginLeft   : 'var(--pixel4)',
										width        : 'var(--font120)',
										height       : 'var(--pixel40)',
										display      : 'flex',
										alignItems   : 'center',
										position     : 'relative'
									}}
								>
									<input
										type='text'
										value={colorStates?.primaryColor}
										name='primaryColor'
										onChange={(e) => handleColorChange(e)}
										style={{
											width           : 'var(--percent100)',
											height          : 'var(--percent100)',
											border          : 'none',
											textAlign       : 'center',
											backgroundColor : 'transparent',
											color           : 'inherit',
											outline         : 'none'
										}}
									/>
								</Box>
							</Stack>
						</Stack>
					</Grid>
					<Grid item xs={12}>
						<Stack direction='column' position='relative'>
							<Typography variant='inherit' sx={{ fontSize: 'var(--pixel14)', fontWeight: '500' }} pl='var(--pixel8)'>
								{language.secondary}
							</Typography>
							<Stack direction='row' alignItems={'center'} pt='var(--pixel4)'>
								<Box
									sx={{
										background   : colorStates?.secondaryColor,
										padding      : 'var(--pixel8)',
										borderRadius : 'var(--pixel4)',
										height       : 'var(--pixel40)',
										width        : 'var(--percent100)',
										margin       : '0 8px'
									}}
								/>
								<input
									id='colorPicker1'
									type='color'
									value={colorStates?.secondaryColor}
									name='secondaryColor'
									onChange={(e) => handleColorChange(e)}
									style={{
										position : 'absolute',
										top      : '0',
										left     : '0',
										width    : 'var(--percent100)',
										height   : 'var(--percent100)',
										opacity  : '0',
										cursor   : 'pointer'
									}}
								/>
								<Box
									sx={{
										border       : '1px solid #636363',
										padding      : 'var(--pixel4)',
										borderRadius : 'var(--pixel4)',
										marginRight  : 'var(--pixel8)',
										marginLeft   : 'var(--pixel4)',
										width        : 'var(--font120)',
										height       : 'var(--pixel40)',
										display      : 'flex',
										alignItems   : 'center',
										position     : 'relative'
									}}
								>
									<input
										type='text'
										value={colorStates?.secondaryColor}
										name='secondaryColor'
										onChange={(e) => handleColorChange(e)}
										style={{
											width           : 'var(--percent100)',
											height          : 'var(--percent100)',
											border          : 'none',
											textAlign       : 'center',
											backgroundColor : 'transparent',
											color           : 'inherit',
											outline         : 'none'
										}}
									/>
								</Box>
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			</Box>
		</Stack>
	);
};

export default Theming;
